import { Injectable } from '@angular/core';


declare const fbq;
@Injectable()
export class FacebookPixelService {
  constructor() { }

  public trackEvent(eventName: string, properties: Object) {
    if (typeof fbq === 'undefined') {
      return;
    }
    fbq('track', eventName, properties);
  }

  public trackCustomEvent(eventName: string, properties: Object) {
    if (typeof fbq === 'undefined') {
      return;
    }
    fbq('trackCustom', eventName, properties);
  }
}
